/** `true` se `str` for um JSON válido (objeto, array, ou qualquer valor
 * JSON) — usado no `validate()` do step de identidade antes de mandar pro
 * backend, que faz a mesma checagem (defesa em profundidade). */
export function isValidJson(str: string): boolean {
  if (!str.trim()) return true; // vazio = "não mexer", tratado à parte
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}
